import api from "./apiClient";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Démarre la connexion Google via NOTRE propre client OAuth (branding Cehnura),
// pas via un fournisseur managé. Le callback est géré par la route /auth/google.
export async function startGoogleLogin() {
  const { data } = await api.get("/auth/google/client-id");
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem("g_oauth_state", state);
  const redirectUri = window.location.origin + "/auth/google";
  const params = new URLSearchParams({
    client_id: data.client_id,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    access_type: "offline",
    include_granted_scopes: "true",
    prompt: "select_account",
    state,
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
